(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["regional-bis-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    class RegionalBisModal extends ModalDialog {
      constructor() {
        super();
        this.form = this.querySelector('[data-rb-form]');
        this.titleEl = this.querySelector('[data-rb-title]');
        this.variantWrapper = this.querySelector('[data-rb-variant-wrapper]');
        this.variantSelect = this.querySelector('[data-rb-variant-select]');
        this.emailInput = this.querySelector('input[name="email"]');
        this.submitBtn = this.querySelector('[data-rb-submit]');
        this.submitCopy = this.querySelector('[data-rb-submit-copy]');
        this.successEl = this.querySelector('[data-rb-success]');
        this.successCopy = this.querySelector('[data-rb-success-copy]');
        this.errorEl = this.querySelector('[data-rb-error]');
        this.errorCopy = this.querySelector('[data-rb-error-copy]');
        this.data = JSON.parse(this.querySelector('[data-rb-json]').textContent);
        this.defaultSubmitCopy = this.submitCopy.textContent;
        this.defaultErrorCopy = this.errorCopy.textContent;

        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        // ModalDialog's own backdrop-click handler only matches its literal
        // <modal-dialog> tag name, so it never fires for this custom tag.
        this.addEventListener('click', (e) => {
          if (e.target === this) this.hide();
        });
      }

      show(opener) {
        super.show(opener);
        this.resetMessages();
        this.populate();
        if (this.data.variants.length === 0) {
          // Every variant is back in stock (a stale trigger fired after a
          // restock, before the page re-checked availability) — there's
          // nothing left to notify on.
          this.form.hidden = true;
          this.errorCopy.textContent = 'This item is back in stock.';
          this.errorEl.hidden = false;
        } else {
          this.emailInput.focus();
        }
      }

      populate() {
        const { product, variants, selectedVariantId } = this.data;
        this.titleEl.textContent = product.title;

        const mainOptionSelect = document.querySelector('[data-option-main]');
        const requestedVariantId = mainOptionSelect && mainOptionSelect.value
          ? Number(mainOptionSelect.value)
          : selectedVariantId;

        // this.data.variants is already filtered server-side to out-of-stock
        // options only. If the page's active variant isn't one of them, fall
        // back to the first out-of-stock option instead of pointing the
        // alert at a variant that's actually available.
        const activeVariantId = variants.some((v) => v.id === requestedVariantId)
          ? requestedVariantId
          : (variants[0] && variants[0].id);

        this.activeVariantId = activeVariantId;

        if (this.data.hasOnlyDefaultVariant) {
          this.variantWrapper.classList.add('is-hidden');
        } else {
          this.variantSelect.innerHTML = variants
            .map((variant) => `<option value="${variant.id}">${variant.title}</option>`)
            .join('');
          this.variantSelect.value = activeVariantId;
          this.variantWrapper.classList.remove('is-hidden');
        }
      }

      resetMessages() {
        this.successEl.hidden = true;
        this.errorEl.hidden = true;
        this.form.hidden = false;
      }

      handleSubmit(event) {
        event.preventDefault();

        const variantId = this.data.hasOnlyDefaultVariant
          ? this.activeVariantId
          : Number(this.variantSelect.value);
        const variant = this.data.variants.find((v) => v.id === variantId) || {};

        const payload = {
          email: this.emailInput.value.trim(),
          variant_id: variantId,
          variant_title: variant.title || '',
          variant_image: variant.image || '',
          variant_url: variant.url || this.data.product.url,
          product_id: this.data.product.id,
          product_title: this.data.product.title,
          product_handle: this.data.product.handle,
          product_url: this.data.product.url,
          warehouse: this.data.warehouse,
          market: this.data.market,
          shop: this.data.shop,
          timestamp: new Date().toISOString(),
        };

        this.submitBtn.disabled = true;
        this.submitCopy.textContent = '…';
        this.errorEl.hidden = true;

        // A plain POST with a text/plain body avoids a CORS preflight (Apps
        // Script has no doOptions to answer one), and script.google.com adds
        // Access-Control-Allow-Origin itself, so the JSON response is
        // readable without mode: 'no-cors'.
        fetch(this.data.webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload),
        })
          .then((res) => res.json().catch(() => ({ status: res.status })))
          .then((data) => {
            const succeeded = data && data.status >= 200 && data.status < 300;
            if (succeeded) {
              this.successCopy.textContent = `We'll be in touch as soon as ${this.data.product.title} becomes available.`;
              this.successEl.hidden = false;
              this.form.hidden = true;
            } else {
              this.errorCopy.textContent = (data && data.message) || this.defaultErrorCopy;
              this.errorEl.hidden = false;
            }
          })
          .catch(() => {
            this.errorCopy.textContent = this.defaultErrorCopy;
            this.errorEl.hidden = false;
          })
          .finally(() => {
            this.submitBtn.disabled = false;
            this.submitCopy.textContent = this.defaultSubmitCopy;
          });
      }
    }

    if (!customElements.get('regional-bis-modal')) {
      customElements.define('regional-bis-modal', RegionalBisModal);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
